import { createFileRoute, getRouteApi } from '@tanstack/react-router';
import { BrandCommunicationSection } from '../components/brand-communication-section.js';

const parentRoute = getRouteApi('/brand/$slug/settings');

// WHERE mag reaches you (spec d9d347f4). The slack oauth callback
// returns HERE — apps/api/src/notifications/slack/routes.ts spells this
// path out as a literal, because SlackConnectStatus lives inside the
// slack card on this pane and is the only thing that renders the
// `?slack=` flag. Rename this route and that literal has to move too.
export const Route = createFileRoute('/brand/$slug/settings/communication')({
  component: CommunicationPage,
});

function CommunicationPage() {
  const { brand } = parentRoute.useLoaderData();
  return <BrandCommunicationSection brand={brand} />;
}
